import React, { ReactElement } from 'react';
import './MoreInfo.scss';
import { Information } from '../Information/information';

interface MoreInfoProps {
    tags: string[];
    synopsis: string;
}

const MoreInfo = ({ tags = [''], synopsis }: MoreInfoProps): ReactElement => {
    return (
        <div className='series-more-info-container'>
            <div className='info-inky-mobile'>
                <Information />
            </div>

            <div className='series-more-info-description-wrapper'>
                <div className='series-more-info-synopsis-container'>
                    <span className='series-more-info-description-title'>Synopsis</span>
                </div>
                <p className='series-more-info-description-text' dangerouslySetInnerHTML={{ __html: synopsis }}>
                    {/*{synopsis}*/}
                </p>
            </div>
        </div>
    );
};

export default MoreInfo;